import { Autocomplete, TextField } from "@mui/material";
import { FormikProps } from "formik";

import { CaseNoteFormValues } from "@/pages/clients/client/components/tabs/notes-tab/components/case-note-form/CaseNoteForm.types";
import { useTranslation } from "@/translations";

import { useCaseNoteTemplateSelect } from "./hooks/useCaseNoteTemplateSelect";

interface Props {
  formik: FormikProps<CaseNoteFormValues>;
  clientId: string;
}

export function CaseNoteTemplateSelect({ formik, clientId }: Props) {
  const { t } = useTranslation();
  const { templates, selectedTemplate, handleSelect } = useCaseNoteTemplateSelect(formik, clientId);

  return (
    <Autocomplete
      value={selectedTemplate}
      onChange={(_, newValue) => handleSelect(newValue)}
      options={templates}
      size="small"
      getOptionLabel={(option) => option.title}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      fullWidth
      noOptionsText={t("clients.client.caseNotes.form.noTemplates")}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            minWidth: "0em",
            "& .MuiInputBase-inputSizeSmall": { fontSize: "0.875rem" },
            "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input": {
              paddingY: "2px",
            },
          }}
          margin="none"
          variant="outlined"
          size="small"
          slotProps={{ inputLabel: { sx: { fontSize: "0.875rem" } } }}
          label={t("clients.client.caseNotes.form.template")}
        />
      )}
    />
  );
}
